import { useEffect, useState } from 'react';
import { publicSettings } from '../api/publicSettings';

/**
 * The home country InGo's Settings, Regional names (InGo ADR 0037): what a
 * sign-up page's country starts on, and the example number it hints. Null
 * until the API answers, and when it cannot: the person then picks.
 *
 * @returns {{ code: string, name: string, dialCode: string, phoneExample: string } | null}
 */
export function useHomeCountry() {
  const [home, setHome] = useState(null);

  useEffect(() => {
    let gone = false;
    publicSettings.region().then(
      (region) => !gone && setHome(region?.home ?? null),
      () => {},
    );

    return () => {
      gone = true;
    };
  }, []);

  return home;
}

/**
 * The home country and every country InGo operates in (Settings, Regional),
 * for judging a phone number's length (`lib/phoneShape.js`). Null until the
 * API answers, and when it cannot.
 *
 * @returns {{ home: object, countries: object[] } | null}
 */
export function useRegion() {
  const [region, setRegion] = useState(null);

  useEffect(() => {
    let gone = false;
    publicSettings.region().then(
      (answer) => !gone && setRegion(answer ?? null),
      () => {},
    );

    return () => {
      gone = true;
    };
  }, []);

  return region;
}

/**
 * A sign-up form's country, once the home is known: the home, unless the
 * person has already chosen one.
 */
export function withHomeCountry(form, home) {
  return home && !form.countryIso ? { ...form, countryIso: home.code } : form;
}
